import {Injectable} from "@angular/core";
import { Badge } from '@capawesome/capacitor-badge';

let queue: {[key: string]: any[]} = {};

@Injectable({
    providedIn: 'root'
})
export class BadgeService {
    private isSupported: boolean = false;
    constructor(
    ) {
        Badge.isSupported().then(result => this.isSupported = result.isSupported);
    }

    public areBadgesSupported() {
        return this.isSupported;
    }

    public async clear() {
        if (!this.isSupported) {
            return;
        }

        await Badge.clear();
    }

    public async set(count: number) {
        if (!this.isSupported) {
            return;
        }

        await Badge.set({ count })
    }

    public async increase() {
        if (!this.isSupported) {
            return;
        }

        await Badge.increase();
    }

    public async decrease() {
        if (!this.isSupported) {
            return;
        }

        await Badge.decrease();
    }
}
